import { DeliveryPoint } from './delivery-point.model';
import { LegalEntity } from './legal-entity.model';
import { Site } from './site.model';

/**
 * Model for API CustomerAccount Model
 */
export class Account {
  /**
   * Account unique id.
   */
  id: number;

  /**
   * Account display name.
   */
  name: string;

  /**
   * Account is pan european.
   */
  panEuropean: boolean;

  /**
   * Account is Reseller
   */
  reseller: boolean;

  /**
   * Legal entities linked to account.
   */
  legalEntities: LegalEntity[];

  /**
   * Sites linked to account.
   */
  sites: Site[];

  /**
   * Pages hidden for the account.
   */
  hiddenPages: string[];

  /**
   * features flag for the account
   * contains all features disabled
   */
  features: string[];

  /**
   * only for display
   */
  isPreferred: boolean;

  /**
   * only for display
   */
  isLastPreferred: boolean;

  /**
   * Third Party Referential
   * returns gemforce account data via TPR api
   */
  gemforceAccountId: number;

  visibleInFront: boolean;

  constructor(attributes: Partial<Account> = {}) {
    Object.assign(this, attributes);
  }

  toString() {
    return this.name;
  }

  equalTo(other: Account): boolean {
    return other.id === this.id;
  }

  searchOn(text: string): boolean {
    return this.name.toLocaleLowerCase().startsWith(text.toLocaleLowerCase());
  }

  deepClone(): Account {
    const sitesCopy = this.sites.map(
      (site: Site) => new Site({ ...site, points: site.points.map((point: DeliveryPoint) => new DeliveryPoint(point)) }),
    );
    return new Account({ ...this, sites: sitesCopy });
  }

  isFeatureEnabled(featureName: string): boolean {
    return !this.features.includes(featureName);
  }
}

export class GemforceAccount {
  /**
   * Gemforce account id is the same as Third Party Referential Account unique id.
   */
  id: number;

  /**
   * Gemforce account name is the same as Third Party Referential Account display name.
   */
  name: string;

  constructor(attributes: Partial<Account> = {}) {
    Object.assign(this, attributes);
  }
}
